import type { ProductBinLocation } from '../types/warehouse';

export function formatZoneCompact(zoneCode: string | null | undefined): string {
  if (!zoneCode) return 'Main Area';
  const m = zoneCode.match(/\d+/);
  return m ? `Z${m[0].padStart(2, '0')}` : zoneCode;
}

export function formatBinPath(location: ProductBinLocation | null | undefined): string {
  if (!location) return '';
  return [location.zone_code, location.rack_code, location.bin_code]
    .filter(Boolean)
    .join(' > ');
}

export function formatBinLocationCompact(location: ProductBinLocation | null | undefined): string {
  if (!location) return '';
  const zMatch = (location.zone_code || '').match(/\d+/);
  const zone = zMatch ? `Z${zMatch[0].padStart(2, '0')}` : '';
  const rMatch = (location.rack_code || '').match(/\d+/);
  const rack = rMatch ? `R${rMatch[0].padStart(2, '0')}` : '';
  const binParts = (location.bin_code || '').split('-');
  const levelPart = binParts[binParts.length - 1] || '';
  const levelNum = levelPart.replace(/[A-Za-z]/g, '');
  const level = levelNum
    ? `L${levelNum.length === 1 ? levelNum.padStart(2, '0') : levelNum}`
    : '';
  return [zone, rack, level].filter(Boolean).join('-');
}
